import { render, staticRenderFns } from "./zgy-course-list.vue?vue&type=template&id=a2dc5b98&scoped=true&"
import script from "./zgy-course-list.vue?vue&type=script&lang=js&"
export * from "./zgy-course-list.vue?vue&type=script&lang=js&"
import style0 from "./zgy-course-list.vue?vue&type=style&index=0&id=a2dc5b98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dc5b98",
  null
  
)

export default component.exports